
/**
 * Created by rathompson on 6/2/22
 * File: GlobalContext
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { createContext } from 'react'
import type { IAMReducerState } from '../reducers/types/IAMReducer.types'
import { IAM_INITIAL_STATE } from '../reducers/IAMReducer'
import type { Action } from '../reducers/actions'

interface IGlobalContext {
  dispatch: (action: Action) => void,
  treeReducer: any,
  viewReducer: any,
  instanceReducer: any,
  appReducer: any,
  licenseReducer: any,
  iamReducer: IAMReducerState,
  deviceReducer: any,
  commonModule: any
}

const context: IGlobalContext = {
  dispatch: () => null,
  treeReducer: {},
  viewReducer: {},
  instanceReducer: {},
  appReducer: {},
  licenseReducer: {},
  iamReducer: IAM_INITIAL_STATE,
  deviceReducer: {},
  commonModule: {}
}

const GlobalContext = createContext(context)

export default GlobalContext
